import { render, staticRenderFns } from "./LeadRenameChildDialog.vue?vue&type=template&id=15f6263b"
import script from "./LeadRenameChildDialog.vue?vue&type=script&lang=ts"
export * from "./LeadRenameChildDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports